(() => {
  const sections = document.querySelectorAll('[data-byes-product-ui="2026"]')

  sections.forEach((section) => {
    section.classList.add('byes-pdp-is-ready')

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const gallery = section.querySelector('.m-product-media--desktop')
    if (!gallery) return

    let frame
    gallery.addEventListener('pointermove', (event) => {
      if (frame) cancelAnimationFrame(frame)
      frame = requestAnimationFrame(() => {
        const bounds = gallery.getBoundingClientRect()
        const x = ((event.clientX - bounds.left) / bounds.width) * 100
        const y = ((event.clientY - bounds.top) / bounds.height) * 100
        gallery.style.setProperty('--byes-pointer-x', `${x.toFixed(1)}%`)
        gallery.style.setProperty('--byes-pointer-y', `${y.toFixed(1)}%`)
      })
    })

    gallery.addEventListener('pointerleave', () => {
      gallery.style.removeProperty('--byes-pointer-x')
      gallery.style.removeProperty('--byes-pointer-y')
    })
  })
})()
